module.exports = __webpack_public_path__ + "img/CATEGORY ICON-31.0b626968.png";